(function () {
    'use strict';

    var publicServices = {
        prepareToScroll: prepareToScroll,
        scroll: scroll,
        cancel: cancel
    };
    var DIRECTIONS = {
        UP: 'SCROLL_UP',
        DOWN: 'SCROLL_DOWN'
    };

    var initialY = 0;
    var startY = 0;
    var lastScrollTime = 0;
    var currentY = 0;
    var distanceToScrollY = 0;

    var SCROLL_ZERO_TOLERANCE = 10;
    var SCROLL_DIFFERENCE_TRIGGER = 10;
    var SCROLL_ANIMATION_TIMER = 10;
    var SCROLL_MIN_TIMER = 100;
    var MOMENTUM_DIVIDER = 10;
    var MOMENTUM_DISTANCE_MULTIPLIER_SLOW = 0.3;
    var MOMENTUM_DISTANCE_MULTIPLIER_FAST = 1.05;
    var MOMENTUM_SPEED_SLOW = 0.15;
    var MOMENTUM_SPEED_FAST = 0.28;

    var isScrolling = false;

    var timer;

    var startTimer;
    var startLastScroll;

    var direction;
    var increment;
    var timeout;
    var viewerElement = null;
    var scrollable = null;
    var tagsToDismiss = ['HTML', 'BODY'];
    function getScrollParent(element, includeHidden, direction) {
        var elemStyle = getComputedStyle(element);
        var excludeStaticParent = elemStyle.position === 'absolute';
        var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;
        var parent;
        if (elemStyle.position === 'fixed') {
            return element.ownerDocument || document;
        }
        for (parent = element; (parent = parent.parentElement);) {
            elemStyle = getComputedStyle(parent);
            if (excludeStaticParent && elemStyle.position === 'static') {
                continue;
            }
            if (parent !== document.documentElement &&
                tagsToDismiss.indexOf(parent.tagName) === -1 &&
                overflowRegex.test(elemStyle.overflowY) &&
                parent.scrollHeight > parent.clientHeight &&
                ((direction === DIRECTIONS.UP && parent.scrollTop > 0) ||
                (direction === DIRECTIONS.DOWN && parent.scrollTop + parent.clientHeight < parent.scrollHeight))) {
                    return parent;
            }
        }
        return element.ownerDocument || document;
    }
    function scrollableIsDocument() {
        return scrollable instanceof HTMLDocument;
    }
    function prepareToScroll(evt) {
        if (timeout) {
            window.clearTimeout(timeout);
        }
        distanceToScrollY = 0;
        increment = null;
        direction = null;
        isScrolling = true;
        startY = evt.clientY;
        initialY = startY;
        currentY = startY;
        viewerElement = evt.wrapper;
        startTimer = Date.now();
    }
    function scroll(evt) {
        var _direction;
        var scrollY;
        var distance;

        currentY = evt.clientY;
        distance = Math.abs(startY - currentY);
        if (direction) {
            _direction = direction;
        }
        if (distance < SCROLL_DIFFERENCE_TRIGGER) {
            return;
        }
        if (startY > currentY) {
            direction = DIRECTIONS.DOWN;
        }
        else {
            direction = DIRECTIONS.UP;
        }
        if (_direction && _direction !== direction) {
            startY = currentY;
            direction = null;
            return;
        }
        if (!viewerElement) {
            return;
        }
        scrollable = getScrollParent(viewerElement, false, direction);
        scrollY = scrollableIsDocument() ? window.pageYOffset : scrollable.scrollTop;
        if (direction === DIRECTIONS.DOWN) {
            scrollY = scrollY + distance;
        }
        else {
            scrollY = scrollY - distance;
            scrollY = scrollY < 0 ? 0 : scrollY;
        }
        if (scrollableIsDocument()) {
            window.scroll(0, scrollY);
        }
        else {
            scrollable.scrollTop = scrollY;
        }
        startY = currentY;
        lastScrollTime = Date.now();
    }
    function cancel(evt) {
        var changedTouch;
        var endTimer;
        var deltaTime;
        var deltaDistance;
        var pxPerSec;
        isScrolling = false;
        if (!evt || Date.now() - lastScrollTime > SCROLL_MIN_TIMER) {
            return;
        }
        changedTouch = evt.changedTouches[0];
        endTimer = Date.now();
        currentY = evt.clientY;

        deltaTime = endTimer - startTimer;
        deltaDistance = Math.abs(currentY - initialY);
        pxPerSec = deltaDistance / deltaTime;
        if (pxPerSec > MOMENTUM_SPEED_FAST) {
            distanceToScrollY = calculateDistanceToScroll(evt.clientY, MOMENTUM_DISTANCE_MULTIPLIER_FAST);
            doLastScroll();
        }
        else if (pxPerSec > MOMENTUM_SPEED_SLOW) {
            distanceToScrollY = calculateDistanceToScroll(evt.clientY, MOMENTUM_DISTANCE_MULTIPLIER_SLOW);
            doLastScroll();
        }
    }

    function doLastScroll() {
        var scrollY;

        document.removeEventListener('touchstart', cancelTimeout);

        startLastScroll = Date.now();
        increment = distanceToScrollY / MOMENTUM_DIVIDER;
        scrollY = scrollableIsDocument() ? window.pageYOffset : scrollable.scrollTop;
        if (direction === DIRECTIONS.DOWN) {
            scrollY = scrollY + increment;
        }
        else {
            scrollY = scrollY - increment;
            scrollY = scrollY < 0 ? 0 : scrollY;
        }

        distanceToScrollY = Math.round(distanceToScrollY - increment);

        if (scrollableIsDocument()) {
            window.scroll(0, scrollY);
        }
        else {
            scrollable.scrollTop = scrollY;
        }

        if (distanceToScrollY > SCROLL_ZERO_TOLERANCE) {
            timeout = window.setTimeout(doLastScroll, SCROLL_ANIMATION_TIMER);
            document.addEventListener('touchstart', cancelTimeout);
        }
        else {
            timeout = null;
            document.removeEventListener('touchstart', cancelTimeout);
        }
    }
    function cancelTimeout() {
        if (timeout) {
            window.clearTimeout(timeout);
            timeout = null;
        }
        document.removeEventListener('touchstart', cancelTimeout);
    }
    function calculateDistanceToScroll(currentFingerPosition, multiplier) {
        var distanceToScrollY = (Math.abs(initialY - currentFingerPosition));
        if (multiplier) {
            distanceToScrollY = distanceToScrollY * multiplier;
        }
        return distanceToScrollY;
    }

    window.cylindo.addModule('cylindo.helpers.scroll', publicServices);
}).call(this);
